<script>
    import { Tabs, Tab, TabList, TabPanel } from "../Tabs/tabs";
    import Exchange from "../stores/Exchanage-contract-store";
    import Lotto from '../stores/Lotto-contract-store'
    import { connected, web3, selectedAccount } from "svelte-web3";
    import { ETHER_Address, ether } from "../helpers";

    let depositEtherAmount
    let depositTokenAmount
    let withdrawEtherAmount
    let withdrawTokenAmount

    $: etherBalance			 	= 	$connected	 ? getBalances() : "";
	$: exchangeEtherBalance 	= 	$Exchange	 ? getBalances() : "";
	$: tokenBalance			    = 	$connected	 ? getBalances() : "";
	$: exchangeTokenBalance	    = 	$Exchange 	 ? getBalances() : "";

    export async function getBalances() {
		etherBalance = ether(await $web3.eth.getBalance($selectedAccount)).toFixed(2)
		exchangeEtherBalance = ether(await $Exchange.methods.balanceOf(ETHER_Address, $selectedAccount).call()).toFixed(2)
		tokenBalance = ether(await $Lotto.methods.balanceOf($selectedAccount).call()).toFixed(2)
		exchangeTokenBalance = ether(await $Exchange.methods.balanceOf($Lotto.options.address, $selectedAccount).call()).toFixed(2)
	}
    async function depositEther(amount){
		$Exchange.methods.depositEther().send({ from: $selectedAccount,  value: $web3.utils.toWei(amount, 'ether') })
		.on('transactionHash', (hash) => {
		})
		.on('receipt', (hash) => {
			depositEtherAmount =""
			getBalances()
		})
		.on('error',(error) => {
			console.error(error)
			window.alert(`There was an error!`)
		})	
	}

	async function depositToken(amount){
		amount = $web3.utils.toWei(amount, 'ether')
		$Lotto.methods.approve($Exchange.options.address, amount).send({ from: $selectedAccount })
		
		.on('transactionHash', (hash) => {
			$Exchange.methods.depositToken($Lotto.options.address, amount).send({ from: $selectedAccount })
			.on('receipt', (hash) => {
                depositTokenAmount=""
                getBalances()
		})
		.on('error',(error) => {
			console.error(error)
			window.alert(`There was an error!`)
		})
	})	
	}

	async function withdrawEther(amount){
		$Exchange.methods.withdrawEther(amount).send({from: $selectedAccount})
		.on('transactionHash', (hash) => {
		})
		.on('receipt', (hash) => {
			withdrawEtherAmount=""
			getBalances()
		})
		.on('error',(error) => {
			console.error(error)
			window.alert(`There was an error!`)
		})	
	}
	async function withdrawToken(amount){
		$Exchange.methods.withdrawToken($Lotto.options.address, amount).send({from: $selectedAccount})
		.on('transactionHash', (hash) => {
		})
		.on('receipt', (hash) => {
			withdrawTokenAmount=""
			getBalances()
		})
		.on('error',(error) => {
			console.error(error)
			window.alert(`There was an error!`)
		})	
	}

</script>

{#if $connected}
{#await getBalances() then}
    <Tabs>
        <TabList>
            <Tab>Deposit</Tab>
            <Tab>Withdraw</Tab>
        </TabList>

        <TabPanel>
            <br />
            <table class="table table-dark table-sm small">
                <thead>
                    <tr>
                        <th>Token</th>
                        <th>Wallet</th>
                        <th>Exchange</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>ETH</td>
                        <td>{etherBalance}</td>
                        <td>{exchangeEtherBalance}</td>
                    </tr>

                    <tr>
                        <td>LTT</td>
                        <td>{tokenBalance}</td>
                        <td>{exchangeTokenBalance}</td>
                    </tr>
                </tbody>
            </table>

            <form class="row">
                <div class="col-8 col-sm pr-sm-2">
                    <input
                        type="text"
                        placeholder="ETH Amount"
                        bind:value={depositEtherAmount}
                        class="form-control form-control-sm bg-dark text-white"
                        required
                    />
                </div>
                <div class="col-3 col-sm-auto pl-sm-0">
                    <button
                        type="submit"
                        class="btn btn-outline-success btn-block btn-sm"
                        on:click|preventDefault={depositEther(
                            depositEtherAmount.toString()
                        )}>Deposit</button
                    >
                </div>
            </form>

            <br />
            <form class="row">
                <div class="col-8 col-sm pr-sm-2">
                    <input
                        type="text"
                        placeholder="LTT Amount"
                        class="form-control form-control-sm bg-dark text-white"
                        required
                        bind:value={depositTokenAmount}
                    />
                </div>
                <div class="col-3 col-sm-auto pl-sm-0">
                    <button
                        type="submit"
                        on:click|preventDefault={depositToken(
                            depositTokenAmount.toString()
                        )}
                        class="btn btn-outline-success btn-block btn-sm">Deposit</button
                    >
                </div>
            </form>
        </TabPanel>

        <TabPanel>
            <br />
            <table class="table table-dark table-sm small">
                <thead>
                    <tr>
                        <th>Token</th>
                        <th>Wallet</th>
                        <th>Exchange</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>ETH</td>
                        <td>{etherBalance}</td>
                        <td>{exchangeEtherBalance}</td>
                    </tr>
                    <tr>
                        <td>LTT</td>
                        <td>{tokenBalance}</td>
                        <td>{exchangeTokenBalance}</td>
                    </tr>
                </tbody>
            </table>

            <form class="row">
                <div class="col-8 col-sm pr-sm-2">
                    <input
                        type="text"
                        placeholder="ETH Amount"
                        class="form-control form-control-sm bg-dark text-white"
                        required
                        bind:value={withdrawEtherAmount}
                    />
                </div>
                <div class="col-3 col-sm-auto pl-sm-0">
                    <button
                        type="submit"
                        on:click|preventDefault={withdrawEther(
                            $web3.utils.toWei(
                                withdrawEtherAmount.toString(),
                                "ether"
                            )
                        )}
                        class="btn btn-outline-danger btn-block btn-sm"
                        >Withdraw</button
                    >
                </div>
            </form>
            <br />

            <form class="row">
                <div class="col-8 col-sm pr-sm-2">
                    <input
                        type="text"
                        placeholder="LTT Amount"
                        class="form-control form-control-sm bg-dark text-white"
                        required
                        bind:value={withdrawTokenAmount}
                    />
                </div>
                <div class="col-3 col-sm-auto pl-sm-0">
                    <button
                        type="submit"
                        on:click|preventDefault={withdrawToken(
                            $web3.utils.toWei(
                                withdrawTokenAmount.toString(),
                                "ether"
                            )
                        )}
                        class="btn btn-outline-danger btn-block btn-sm"
                        >Withdraw</button
                    >
                </div>
            </form>
        </TabPanel>
    </Tabs>
    {/await}
{/if}
